<div *ngrxLet="skalReport$ as skalReport">
  @if (skalReport) {
    <div class="spacing--margin-right">
      <div class="text--label">
        {{ 'totalOrganicFields' | translate }}
      </div>
      <div class="flex--row flex--nowrap flex--align-center">
        @if (skalReport.percentageSkalA < 70) {
          <mat-icon class="text-color--warn">warning</mat-icon>
        }
        @if (skalReport.percentageSkalA >= 70) {
          <mat-icon class="text-color--primary">check</mat-icon>
        }
        <span class="flex__child--auto"
          >&nbsp; {{ skalReport.percentageSkalA | agrNumber: '1.0-0' }}% /
          {{ skalReport.totalArea }} ha
        </span>
      </div>
    </div>
  }
</div>
